import { IoCartOutline } from "react-icons/io5";
import { useCartContext } from "../../Context/CartContext.jsx";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { products } = useCartContext();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/menu/cart");
  };
  return (
    <div
      className="flex flex-1 order-3 xl:w-[100px] h-full justify-end mr-4 items-center cursor-pointer xl:flex-none"
      onClick={handleClick}
    >
      <div className="relative">
        <IoCartOutline className="text-[35px]" />
        <div className="text-white text-[14px] flex justify-center absolute -top-[15px] left-[40%] rounded-full bg-mariposa w-[20px] ">
          {products.length > 0 ? products.length : ""}
        </div>
      </div>
    </div>
  );
};

export default Cart;
